export default "__VITE_ASSET__DPcn90wx__"